import { FC } from "react";

interface TagProps {
  type: string;
  color:
    | "yellow"
    | "red"
    | "green"
    | "blue"
    | "indigo"
    | "purple"
    | "pink"
    | string;
}

const getColor = (color: string) => {
  switch (color) {
    case "yellow":
      return "bg-yellow-100 text-yellow-800";
    case "red":
      return "bg-red-100 text-red-800";
    case "green":
      return "bg-green-100 text-green-800";
    case "blue":
      return "bg-blue-100 text-blue-800";
    case "indigo":
      return "bg-indigo-100 text-indigo-800";
    case "purple":
      return "bg-purple-100 text-purple-800";
    case "pink":
      return "bg-pink-100 text-pink-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

const Tag: FC<TagProps> = ({ type, color }) => {
  return (
    <div>
      <span
        className={`inline-flex items-center rounded-xl px-2 py-0.5 text-xs font-semibold ${getColor(
          color
        )}`}
      >
        {type}
      </span>
    </div>
  );
};

export default Tag;
